import { AbstractLocaleMessageObject } from "@/i18n/AbstractLocaleMessageObject"

export class KeywordCategoryListJa extends AbstractLocaleMessageObject {
  readonly category = "カテゴリ"
  readonly description = "説明"
  readonly categoryFilterPlaceholder = "カテゴリ名、説明で絞り込み"
}
